export default [
  {
    id: '576afda3-badc-498f-99dc-77f106160716',
    path: 'master-data-management',
    name: 'master-data-management',
    meta: { title: '主数据管理' },
    children: [
      {
        id: 'b30b9cc8-85f2-49e9-956d-8964bd4f8190',
        path: 'master-datatype-management',
        name: 'master-datatype-management',
        component: () => {
          return import('../views/masterDataManagement/masterDataTypeManagement')
        },
        meta: {
          title: '主数据类型',
          keepAlive: false,
          operations: {
            create: {
              id: 0,
              name: 'create',
              desc: '新增',
              access: true,
            },
            update: {
              id: 1,
              name: 'update',
              desc: '编辑',
              access: true,
            },
            delete: {
              id: 2,
              name: 'delete',
              desc: '删除',
              access: true,
            },
            export: {
              id: 3,
              name: 'export',
              desc: '导出',
              access: true,
            },
          },
        },
      },
      {
        id: 'ab49e6de-1ef2-46d1-b911-618bdd6b40a8',
        path: 'data-list',
        name: 'data-list',
        component: () => {
          return import('../views/masterDataManagement/dataList')
        },
        meta: {
          title: '主数据清单',
          keepAlive: false,
          operations: {
            export: {
              id: 0,
              name: 'export',
              desc: '导出',
              access: true,
            },
            collect: {
              id: 1,
              name: 'collect',
              desc: '收藏',
              access: true,
            },
            unbookmark: {
              id: 2,
              name: 'unbookmark',
              desc: '取消收藏',
              access: true,
            },
          },
        },
      },
      {
        id: 'edcb17af-8bee-4c06-a44f-417bcc2a43e4',
        path: 'data-distribute',
        name: 'data-distribute',
        component: () => {
          return import('../views/masterDataManagement/dataDistribute')
        },
        meta: {
          title: '主数据分发',
          keepAlive: false,
          operations: {
            create: {
              id: 0,
              name: 'create',
              desc: '新增',
              access: true,
            },
            update: {
              id: 1,
              name: 'update',
              desc: '编辑',
              access: true,
            },
            delete: {
              id: 2,
              name: 'delete',
              desc: '删除',
              access: true,
            },
            export: {
              id: 3,
              name: 'export',
              desc: '导出',
              access: true,
            },
          },
        },
      },
      {
        id: 'ed762373-69e1-4d49-8039-e159e13aceb1',
        path: 'operate-distribute-config',
        name: 'operate-distribute-config',
        component: () => {
          return import('../views/masterDataManagement/operateDistributeConfig')
        },
        meta: {
          title: '主数据分发管理',
          tabnab: false,
          hidden: true,
          keepAlive: false,
          activeMenu: '/legacy-resource/master-data-management/data-distribute',
        },
      },
    ],
  },
]
